import generate from './generate.es.js';
export { default as generate } from './generate.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const functionalColors = {
  primary: "#ee112e",
  secondary: "#0674e8",
  link: "#1990ff",
  pending: "#ffa940",
  success: "#43da71",
  error: "#da4343"
};
const defaultColors = {
  white: "#FFFFFF",
  tableHeader: "#F8F8FC",
  background: "#F3F3F7",
  divider: "#E4E5F0",
  inputBorder: "#e0e0e0",
  disable: "#DCDEE9",
  border: "#BCBFD6",
  placeholder: "#A7ABC3",
  textSecondary: "#82869E",
  textPrimary: "#434657",
  textTitle: "#1B1D29",
  black: "#000000",
  neutral: "#848788",
  text: "#434657",
  primary: "#ee112e",
  secondary: "#0674e8",
  link: "#1990ff",
  pending: "#ffa940",
  success: "#43da71",
  error: "#da4343"
};
let presetPalettes = {};
Object.keys(functionalColors).forEach((key) => {
  presetPalettes = __spreadValues(__spreadValues({}, presetPalettes), generate(functionalColors[key], key));
});
const themeColor = __spreadValues(__spreadValues({}, defaultColors), presetPalettes);

export { themeColor };
